export default __webpack_public_path__ + "static/0171-846ab32fa71cb5700a6c09265455d501.png";